<info>
    <header>
        Udbetaling
    </header>
    <content>
        <p class="header">Hvornår sker udbetaling?</p>
        <p>Udbetaling af gevinster for lodder tilmeldt Betalingsservice, sker altid den 2. bankdag i måneden efter trækningen med gevinst.</p>
        <p class="header">Hvor meget får jeg udbetalt?</p>
        <p>Din gevinstandel kommer an på det type lod du ejer, samt hvilken gevinst der er blevet vundet på loddet. Ejer du et 1/1-lod, undgår du at dele den vundne gevinst med andre. Men med et 1/8-lod, deler du gevinsten med 7 andre vindere, når dit lod udtrækkes.</p>
        <p class="header">Gevinstafgift</p>
        <p>Der skal efter gældende lov betales en afgift på 15% af hver enkelt gevinst, der overstiger 200 kr. Gevinstafgiften er fratrukket, inden gevinsten udbetales.</p>
    </content>
</info>
